import * as React from 'react'
import {FormControl, Select, MenuItem, Theme, createStyles, withStyles, WithStyles, TextField} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import autobind from 'autobind-decorator'

const styles = (t: Theme) => createStyles({
    formControl: {
        width: '100%'
    },
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
  arrOptions: any;
  input: any;
  otherOptionPlaceHolder?: string;
}


interface IStates {
    isOtherSelected: boolean;
    optionSelected: any;
}


class SelectWithField extends React.Component<IProps, IStates> {
  state = {
    isOtherSelected: false,
    optionSelected: this.props.input.value,
  };

  render() {
    const {t, arrOptions, classes, otherOptionPlaceHolder} = this.props
    return (
      <>
          {arrOptions &&
             <FormControl className={classes.formControl}>
                <Select
                    value={this.state.optionSelected}
                    onChange={this.handleSelectChange}
                    fullWidth={true}
                >
                    {arrOptions.map(o => 
                        <MenuItem 
                            key={o} 
                            value={o} 
                        >
                            <span>{o}</span>
                        </MenuItem>
                    )}
                    <MenuItem 
                        key="other" 
                        value="other" 
                    >
                        <span>{t.other}</span>
                    </MenuItem>
                </Select>
                {this.state.isOtherSelected &&
                    <TextField
                        placeholder={otherOptionPlaceHolder ? otherOptionPlaceHolder : t.type_your_answer}
                        onChange={this.handleInputChange}
                        margin="normal"
                    />
                }
            </FormControl>
          }

      </>
    )
  }


  @autobind
  private handleSelectChange(event: any) {
    this.setState({ optionSelected: event.target.value });
    if(event.target.value === "other"){
        this.setState({isOtherSelected: true})
    } else {
        this.setState({isOtherSelected: false})
    }
    this.props.input.onChange(event.target.value);
  };

  @autobind
  private handleInputChange(event: any){
    this.props.input.onChange(event.target.value);
  }

}

export default compose(
  withI18n,
  withStyles(styles)
)(SelectWithField)



// WEBPACK FOOTER //
// ./src/shared/form/SelectWithField.tsx